export default __webpack_public_path__ + "static/media/flag-brazil-active.3570104b.svg";